export interface NewsArticle {
  _id?: string
  title: string
  slug: string
  excerpt: string
  body: string
  featuredImage: string
  gallery?: string[]
  category: string
  author: string
  published: boolean
  shareUrl?: string
  creator: string
  createdAt: string
  updatedAt: string
}

export const NEWS_PAGE_SIZE = 10
export const NEWS_HOME_PAGE_SIZE = 12
